import { Result } from "antd";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from "react-router-dom";
import { roles } from "../config/roles";
import ActivityLog from "../screens/ActivityLog";
import AccountSetup from "../screens/Auth/AccountSetup/AccountSetup";
import CreatePassword from "../screens/Auth/CreatePassword/CreatePassword";
import CustomerLogin from "../screens/Auth/CustomerLogin/CustomerLogin";
import ForgetPassword from "../screens/Auth/ForgotPassword/ForgotPassword";
import Login from "../screens/Auth/Login/Login";
import Signup from "../screens/Auth/SignUp/Signup";
import VerificationProcess from "../screens/Auth/VerificationProcess/VerificationProcess";
import VerifyCode from "../screens/Auth/VerifyCode/VerifyCode";
import BusinessProfileSetup from "../screens/BusinessProfileSetup/BusinessProfileSetup";
import {
  AccountSettings,
  Assets,
  BusinessProfile,
  DealershipDashboard,
  FAQ,
  Inventory,
  LoRaWanControl,
  ModuleRegistration,
  Order,
  Products,
  Reports,
  SalesHistory,
  ScanQR,
} from "../screens/Dealership";
import LisenceManagement from "../screens/Dealership/LisenceManagement/LisenceManagement";
import HelpSupport from "../screens/HelpSupport/HelpSupport";
import Notifications from "../screens/Notifications/Notifications";
import PrivacyPolicy from "../screens/PrivacyPolicy/PrivacyPolicy";
import SharedAccess from "../screens/SharaedAccess";
import TermsConditions from "../screens/TermsConditions/TermsConditions";
import {
  AddVehical,
  AddVehicalInformation,
  Module,
  UserAssets,
  UserDashboard,
} from "../screens/User";
import { ProtectedLayout, ProtectedRoute } from "./ProtectedRoutes";
import { HomeLayout, RolesLayout } from "./PublicRoutes";
import { CompanyPortal } from "../screens/ComapanyPortal";
import ResetPassword from "../screens/Auth/ResetPasswrd";
import AuthFromQuery from "./AuthFromQuery";
import LotNumber from "../screens/Dealership/LotNumber/lotnumber";
import React from "react";
import { ADMIN_URL, ADMIN_URL_LIVE, BASE_URL } from "../config/Apis";
// import MapTracker from "../components/MapTracker/MapTracker";
// import { roles } from "../config/roles";

const ExternalRedirect = ({ url }) => {
  React.useEffect(() => {
    window.location.href = url;
  }, [url]);

  return (
    <p style={{ textAlign: "center", marginTop: "20%" }}>Redirecting...</p>
  );
};

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        element={
          <>
            <AuthFromQuery />
            <HomeLayout />
          </>
        }
      >
        <Route path="/" element={<Login />} />
        <Route path="/forgotPassword" element={<ForgetPassword />} />
        <Route path="/verifyCode" element={<VerifyCode />} />
        <Route path="/createPassword" element={<CreatePassword />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/company-portal" element={<CustomerLogin />} />

        {/* <Route path="/selectrole" element={<SelectRole />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgotPassword" element={<ForgetPassword />} />
        <Route path="/verificationCode" element={<VerificationCode />} />
        <Route path="/enterNewPassword" element={<NewPassword />} /> */}
      </Route>
      <Route element={<ProtectedLayout roles={[roles.company]} />}>
        {/* =================================================== dealership Screens  ======================================= */}
        <Route element={<RolesLayout roles={[roles.dealership]} />}>
          <Route path="/dashboard" element={<DealershipDashboard />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/assets" element={<Assets />} />
          <Route path="/products" element={<Products />} />
          <Route path="/businessProfile" element={<BusinessProfile />} />
          <Route path="/loRaWanControl" element={<LoRaWanControl />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/lisenceManagement" element={<LisenceManagement />} />
          <Route path="/lot-name" element={<LotNumber />} />
          <Route path="/activity-logs" element={<ActivityLog />} />
          {/* <Route path="/tracking" element={<MapTracker />} /> */}
        </Route>
        <Route element={<RolesLayout roles={[roles.user]} />}>
          <Route path="/userDashboard" element={<UserDashboard />} />
          <Route path="/module" element={<Module />} />
          <Route path="/userAssets" element={<UserAssets />} />
        </Route>
        <Route element={<RolesLayout roles={[roles.company]} />}>
          <Route path="/company-dashboard" element={<CompanyPortal />} />
        </Route>
        <Route path="/shared-access" element={<SharedAccess />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/helpSupport" element={<HelpSupport />} />
        <Route path="/accountSettings" element={<AccountSettings />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/terms&conditions" element={<TermsConditions />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route element={<RolesLayout roles={[roles.dealership]} />}>
          {/* <Route path="/userModuleRegistration" element={<UserModuleRegistration />} /> */}
          <Route path="/order" element={<Order />} />
          <Route path="/salesHistory" element={<SalesHistory />} />
          <Route path="/accountSetup" element={<AccountSetup />} />
          <Route
            path="/verificationProcess"
            element={<VerificationProcess />}
          />
          <Route
            path="/businessProfileSetup"
            element={<BusinessProfileSetup />}
          />
        </Route>
        <Route element={<RolesLayout roles={[roles.dealership, roles.user]} />}>
          {/* <Route path="/userModuleRegistration" element={<UserModuleRegistration />} /> */}
          <Route path="/moduleRegistration" element={<ModuleRegistration />} />
          <Route path="/scanQR" element={<ScanQR />} />
        </Route>
        <Route element={<RolesLayout roles={[roles.user]} />}>
          <Route path="/addVehical" element={<AddVehical />} />
          <Route
            path="/addVehicalInformation"
            element={<AddVehicalInformation />}
          />
        </Route>
      </Route>
      {/* </Route> */}
      <Route
        path="*"
        element={
          <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            // extra={<Button type="primary">Back Home</Button>}
          />
        }
      />
      <Route
        path="/adminpanel"
        element={
          <ExternalRedirect
            url={
              BASE_URL === `https://phoeniximmobilizer.com/api`
                ? ADMIN_URL_LIVE
                : ADMIN_URL
            }
          />
        }
      />
    </>,
  ),
);
